import React,{useState, useEffect} from "react";
import { Row, Col, Container, Button} from "react-bootstrap";
import { useParams } from 'react-router-dom';
import authService from "../services/authServices";
import "../css/About.css"

const About = () => {
  return (
  <>
    <div style={{paddingTop:"150px"}}>
      <Row style={{display:"flex", justifyContent:"center"}}>
      <h1>
        This is our team
      </h1>
      </Row>
      <Row style={{display:"flex", justifyContent:"center", margin:"50px"}}>
        <Col style={{margin:"50px"}}>
          <h2>
            Anakin Ha
          </h2>
        </Col>
        <Col  style={{margin:"50px"}}>
          <h2>
             Jeremy Pacheco
          </h2>
        </Col>
        <Col  style={{margin:"50px"}}>
          <h2>
            Rygiel Corpuz
          </h2>
        </Col>
        <Col  style={{margin:"50px"}}>
          <h2>
            Tri Pham
          </h2>
        </Col>
      </Row>
    </div>
  </>
  );
};

export default About; 
